exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "changespercoder .bold{color:#ff91a4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/reports/changespercoder/changespercoder.styl
// module id = 64
// module chunks = 1